/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {Query} from "react-apollo";
import {gql} from "apollo-boost";
import {Carousel} from "react-responsive-carousel";
import BASIOverallVIXSP from "../../components/Charts/BASI/BASIOverallVIXSP";
import BASIByTradeSize from "../../components/Charts/BASI/BASIByTradeSize";
import BASISectorIndexes from "../../components/Charts/BASI/BASISectorIndexes";
import BASISpecialtyIndexes from "../../components/Charts/BASI/BASISpecialtyIndexes";
import BASIEuropean from "../../components/Charts/BASI/BASIEuropean";
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {filterHTML} from "../../helpers/filters";

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldHtmlBody: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldBasiSectionStyle: Array<{entity: Array}>;
    }
}

class OnTheMarketChartsStaticQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentChartBasi {
          fieldTxtHeadline
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldBasiSectionStyle {
          	${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

const OnTheMarketChartsStatic = ({id, markComponentLoadedAs}) => (

    <OnTheMarketChartsStaticQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const styles = fieldObjectSectionStyleCss(field.fieldBasiSectionStyle);

            markComponentLoadedAs(id, true);

            return (
                <div className={`basichartsstatic${styles.classNames}`} style={styles.css}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="container" style={{margin: '0 auto'}}>

                        <h2 style={{textAlign: 'center'}}>
                            {field.fieldTxtHeadline || 'BASI Charts'}
                        </h2>

                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            <p dangerouslySetInnerHTML={{__html: filterHTML(field.fieldHtmlBody.processed || '')}} />
                        )}
                        {(!field.fieldHtmlBody || !field.fieldHtmlBody.processed) && (
                            <p>
                                The MarketAxess Bid-Ask Spread Index (BASI)™ tracks the daily spread between bids and offers in certain
                                U.S. high grade (HG) segments using BondTicker™ market data. Specialty BASI and Sector BASI are designed
                                to reflect observed institutional credit market activity, and provide greater insight into trading
                                costs.
                            </p>
                        )}
                        <Carousel showArrows
                                  showIndicators={false}
                                  swipeable={false}
                                  emulateTouch={false}
                                  showThumbs={false}
                                  showStatus={false}>
                            <BASIEuropean/>
                            <BASIOverallVIXSP/>
                            <BASIByTradeSize/>
                            <BASISectorIndexes/>
                            <BASISpecialtyIndexes/>
                        </Carousel>
                    </div>
                </div>
            );
        }}
    </OnTheMarketChartsStaticQuery>

);

OnTheMarketChartsStatic.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired
};

export default OnTheMarketChartsStatic;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/BASIChartsStatic.jsx